import React, { FC } from 'react'
import { FormulaWidgetData } from 'models/widget'
import { Text } from 'components/Text'
import { Heading } from 'components/Heading'
import { readableNumber } from 'utils/readableNumber'
import { useTranslation } from 'react-i18next'

type FormulaProps = {
  data: FormulaWidgetData
}

export const Formula: FC<FormulaProps> = ({ data }) => {
  const { t } = useTranslation()
  const count: number[] = Array.isArray(data.count) ? data.count : [data.count]

  return (
    <div>
      <div>
        {data.prefix && (
          <Heading size="widget" component="span">
            {data.prefix}
          </Heading>
        )}

        <Heading size="secondary" component="span">
          {count.map((num) => readableNumber(num)).join(` ${t('widgets.vs')} `)}
        </Heading>

        {data.suffix && (
          <Heading size="widget" component="span">
            {data.suffix}
          </Heading>
        )}
      </div>
      <Text>{data.desc}</Text>
    </div>
  )
}

Formula.displayName = 'Formula'
